import React from 'react'
import {getUserSettings, getUserProfile} from '../../storage'
import DefaultInvoice from './newinvoice'
import ComponsitionInvoice from './compositioninvoice'
import BatchInvoice from './batchinvoice'
import BarcodeInvoice from './barcodeinvoice'
import InvoiceMobi from './invoicemobi'
import InvocieService from './invoiceservice'
import InvoiceModern from './invoicemodern'
import InvoiceSimpleService from './invoicesimpleservice'

export default class InvoiceMode extends React.Component {


  render()  {
    let settings = getUserSettings()
    let profile = getUserProfile()

    if(typeof profile !== "undefined" && profile.tax_type === "C") {
      return <ComponsitionInvoice {...this.props} />
    }
    else if (typeof settings !== "undefined" && settings !== null && settings.invoice_entry_mode == 'modern'){
      return <InvoiceModern {...this.props} />
    }
    else if (typeof settings !== "undefined" && settings !== null && settings.invoice_entry_mode == 'service'){
      return <InvocieService {...this.props} />
    }
    else if (typeof settings !== "undefined" && settings !== null && settings.invoice_entry_mode == 'mobile'){
      return <InvoiceMobi {...this.props} />
    }
    else if (typeof settings !== "undefined" && settings !== null && settings.invoice_entry_mode == 'simple_service'){
      return <InvoiceSimpleService {...this.props} />
    }
    else if(typeof settings !== "undefined" && settings !== null && (settings.invoice_barcode_entry || settings.invoice_entry_mode == "fashion")) {
        return <BarcodeInvoice {...this.props} />
    }
    else if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
        return <BatchInvoice {...this.props} />
    }
    else {
        return <DefaultInvoice {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/invoiceselect.js